import { CasoDeUsoBean } from "../../casosDeUso";
import { HistoriaDeUsuario } from "../../historiaUsuario";
import { Base } from "../core/base.model";

export class TareaHuCu extends Base{
	id: number;
	nombre: string; 
	descripcion: string;
	estatus: string; 
	tiempoEstimado: number; 
	tiempoReal: number 
	responsable: number; 
	fechaRegistro: Date; 
	tipo: string;
	idtipo: number;
	clasificacion: string;
	
    historiaUsuario: HistoriaDeUsuario;
	casoUso: CasoDeUsoBean;
}